import React from "react";

import { Box, useTheme, Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import useDialogState from "@/hooks/useDialogState";
import AddGoalButton from "@/pages/Clients/Buttons/AddGoalButton";
import EditIconButton from "@/pages/Clients/IconButtons/EditIconButton";
import { colors } from "@/theme/overrides/colors";

import DeleteWeight from "./DeleteWeightModal";
import EditWeightGoalModal from "./EditWeightGoalModal";
import ScaleIcon from "../../../../../../components/Icons/ScaleIcon";

const useStyles = makeStyles()((theme: Theme) => ({
  weightGoal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: colors.light,
    padding: theme.spacing(1),
  },
}));

interface Props {
  title: string;
  weightGoal: number | undefined | null;
  weightGoalPresent: boolean;
  onDelete: () => void;
}

const WeightGoal: React.FC<Props> = ({
  weightGoal,
  title,
  onDelete,
  weightGoalPresent,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const addCurrentWeightDialog = useDialogState();
  const editCurrentWeightDialog = useDialogState();

  return (
    <>
      <Box className={classes.weightGoal}>
        <Box display="flex" alignItems="center">
          <ScaleIcon fontSize="large" />
          <Box marginRight={theme.spacing(1)} />
          <Typography variant="body1" fontWeight="bold">
            Goal Weight
          </Typography>
        </Box>
        {weightGoalPresent ? (
          <Box display="flex" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              {weightGoal} kg
            </Typography>
            <EditIconButton onClick={() => editCurrentWeightDialog.show()} />
            <DeleteWeight
              onDelete={onDelete}
              title="Delete goal weight"
              message="Do you really want to delete goal weight?"
            />
          </Box>
        ) : (
          <AddGoalButton onClick={() => editCurrentWeightDialog.show()} />
        )}
      </Box>

      <EditWeightGoalModal
        visibility={editCurrentWeightDialog.shown}
        onClose={() => editCurrentWeightDialog.hide()}
        weightGoal={weightGoal}
        title={title}
        goalPresent={weightGoalPresent}
        modalTitle={weightGoalPresent ? "Edit" : "Add"}
      />
    </>
  );
};

export default WeightGoal;
